document.addEventListener('DOMContentLoaded', function() {
  var checkbox = document.getElementsByClassName('futurecash-checkbox');
  let checkboxInfo;
  let phoneForm;  
  let thankYou;
  let errorMessage;
  let loading;
  var futureModal = document.getElementById('futurecash-modal');
  var openModal = document.getElementsByClassName('info-button');
  var closeModal = document.getElementsByClassName("close")[0];
  var claimButton = document.getElementById('claim-button');
  var secretPhoneForm = document.getElementById('secret-futurecash');
  var productInfo = document.getElementById('futurecash-productPage');
 
  // Function to format phone number
  function formatPhoneNumber(value) {
    let digits = value.replace(/\D/g, '');
    
    if (digits.length <= 3) {
      return digits;
    } else if (digits.length <= 6) {
      return digits.slice(0, 3) + '-' + digits.slice(3);
    } else {
      return digits.slice(0, 3) + '-' + digits.slice(3, 6) + '-' + digits.slice(6, 10);
    }
  }

  // Function to handle phone number submissions
  function phoneNumberSubmission(input, button, phoneForm, checkboxInfo, thankYou, errorMessage, loading, box) {

    // Phone number format and validation
    let phoneNumber = input.value;
    phoneNumber = phoneNumber.replace(/[^0-9+]/g, '');
  
    // Validate phone number length
    if (phoneNumber.length === 10) {
      loading.style.display = 'block';
      box.style.display = 'none';
      checkboxInfo.style.display = 'none';
                
        // Correct the phone number format
        if (!phoneNumber.startsWith('+1')) {
          phoneNumber = '+1' + phoneNumber;
        }
        
        // Build request data
        const requestData = {
          number: phoneNumber
          // do we need any more data?
        };
        
        // Twilio endpoint for FutureCash
        const apiUrl = 'https://futurecash-grownasfoods-6166.twil.io/future-cash';
        
        // Make the fetch API call
        fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        })
        .then(response => response.json())
        .then(data => {
          console.log('Success:', data);
          loading.style.display = 'none';
          thankYou.style.display = 'block';
        })
        .catch((error) => {
          console.error('Error:', error);
          loading.style.display = 'none';
          box.style.display = 'block';
          checkboxInfo.style.display = 'block';
          errorMessage.style.display = 'block';
        }); 
        } else {
          errorMessage.style.display = 'block';
        }
  }
  
  // Event listeners for the checkbox and phone form
  if(checkbox && checkbox.length > 0) {
    Array.from(checkbox).forEach(function(box) {
      box.addEventListener('click', function() {
        // figure out which futurecash box the user is interacting with
        phoneForm = box.closest('.futurecash-checkout').querySelector('.phone-form');
        checkboxInfo = box.closest('.futurecash-checkout').querySelector('.checkbox-info');
        thankYou = box.closest('.futurecash-checkout').querySelector('.thank-you');
        errorMessage = box.closest('.futurecash-checkout').querySelector('.error-msg');
        loading = box.closest('.futurecash-checkout').querySelector('.loading');
        
        if (box.checked) {
          phoneForm.style.display = 'block';

          const input = phoneForm.querySelector("#phone");
          const button = phoneForm.querySelector("#btn");
          
          // Submit phone number
          button.addEventListener('click', () => {
            event.preventDefault();
            phoneNumberSubmission(input, button, phoneForm, checkboxInfo, thankYou, errorMessage, loading, box);
          })
          
          // Apply formatting on keyup
          input.addEventListener('keyup', function() {
              input.value = formatPhoneNumber(input.value);
          });
          
        } else {
          phoneForm.style.display = 'none';
        }
      })
    })
  }
 
  // Open phone form on product page
  if (claimButton) {
    claimButton.onclick = function() {
      secretPhoneForm.style.display = "block";
      productInfo.style.display = "none";
    }
  }

  // Open and close modal
  if(openModal) {
    Array.from(openModal).forEach(function(button) {
      button.addEventListener('click', function() {
          futureModal.style.display = "block";
          event.stopPropagation();
      });
    });
  }

  if(closeModal) {
    closeModal.onclick = function() {
      futureModal.style.display = "none";
    }
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (!futureModal.contains(event.target)) {
      futureModal.style.display = "none";
    }
  }
  
});